import React from 'react';
import MainLayout from '../layouts/MainLayout';

const MarinaParsed: React.FC = () => {
  return (
    <MainLayout>
      <div className="page-banner">
        <div className="container">
          <h1>Marina Services</h1>
          <p>Explore the waters of Fallen Leaf Lake</p>
        </div>
      </div>

      <section className="marina-services">
        <div className="container">
          <div className="section-intro">
            <h2>Full-Service Marina</h2>
            <p>Our marina offers a variety of services to help you make the most of your time on Fallen Leaf Lake. Whether you're looking to rent a boat for a few hours or need a seasonal mooring for your own vessel, we have options to suit your needs.</p>
          </div>
          
          <div id="rentals" className="rentals-section">
            <h3>Boat Rentals</h3>
            <div className="rentals-grid">
              {/* This content will be replaced by the actual vessel listing from your reservation system */}
              <p>Loading vessel options...</p>
            </div>
            <div className="cta-button">
              <a href="/vessels" className="btn primary">View All Rental Options</a>
            </div>
          </div>
        </div>
      </section>
    </MainLayout>
  );
};

export default MarinaParsed; 